import axios from 'axios'
import qs from 'qs'
import { MessageBox, Loading } from 'element-ui'
import BaseConfig from '../config/URLConfig'
import { isInArray } from './GlobalFunction'
import store from '@/store/index'

let API_URL
if (process.env.NODE_ENV !== 'development') {   //生产环境
  API_URL = BaseConfig.API_URL
} else {
  API_URL = BaseConfig.DEV_API                  //开发环境
}
//版本号
const SION = '3.5.0';
const _axios = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  },
  transformRequest: [data => {
    return qs.stringify(data)
  }],
  transformResponse: [data => {
    //判断如果是下载文件类型，直接返回data
    if(data instanceof Blob){return data}
    // if(data.)
    let resData = JSON.parse(data);
    //不弹出错误提示的代码
    if (isInArray(BaseConfig.AlertPass, resData.code)) {
      //直接退出登录
      if(resData.code === '60001'||resData.code === '60000'){
        store.dispatch('exit');
        return
      }
      //登录过期直接执行退出登录
      if (resData.code === '10008'||resData.code === '10009') {                    
        store.dispatch('logout',false);
      }
      //多开网页认证提示信息后退出登录
      if(resData.code === '10111'||resData.code === '10110'){
        MessageBox.alert(resData.msg, '提示', {
          type: 'error',
          center: true
        }).then(() => {
          store.dispatch('logout',false);
        })
      }
      return resData
    } else {
      MessageBox.alert(resData.msg, '提示', {
        type: 'error',
        center: true
      }).then(() => {
        if (resData.code == '40015') {
          window.localStorage.setItem('VERSION', JSON.stringify(SION))
          // window.location.href = '/'
          window.location.reload(true)
        }
      })
      return {}
    }
  }]
})
/*发送请求时进行统一处理*/
_axios.interceptors.request.use(function (config) {
  let token = store.getters.tokenMsg
  //token不存在判断为已退出登录
  //在需要token的所有的请求头中加入token
  if (!isInArray(BaseConfig.TokenPass, config.url) && token) {
    config.data.needToken = token;
    config.data.needType = 1;
  }
  // if (VERSION) {                           //发送版本号
  //   console.log('banbe', VERSION)
  //   config.data.version = VERSION;
  // } else {
  //   MessageBox.alert('平台版本更新，如操作失败可尝试刷新页面后重新操作', '提示', {
  //     type: 'warning',
  //     center: true
  //   }).then(() => {
  //     window.localStorage.setItem('VERSION', VERSION);
  //     window.location.href = '/';      //不存在版本号时，刷新当前页面，种下版本号
  //   })
  // }
  if (window.localStorage.getItem('VERSION')) {                           //发送版本号
    config.data.version = window.localStorage.getItem('VERSION');
  } else {
    MessageBox.alert('平台版本更新，如操作失败可尝试刷新页面后重新操作', '提示', {
      type: 'warning',
      center: true
    }).then(() => {
      window.localStorage.setItem('VERSION', window.localStorage.getItem('VERSION'));
      window.location.href = '/';      //不存在版本号时，刷新当前页面，种下版本号
    })
  }
  return config
}, error => console.log(error))
/*收到返回后统一处理*/
_axios.interceptors.response.use(config => {
  return config.data                                   //返回json
}, error => {
  // MessageBox.alert('请求服务器出错', '提示', {
  //   type: 'error',
  //   center: true
  // }).then(() => {
  //   //window.location.href = '/'
  //   window.location.reload()
  // })
})

export default _axios
